const n = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, e = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, s = {};
function _(t, o) {
  return (s.jsx ? e : n).test(t);
}
export {
  _ as name
};
//# sourceMappingURL=index.js.map
